import { useCommonActionFromDALV2 } from '@shares/actionFormDALV2';
import { CommonNotificationSaveError } from '@shares/CommonNotification';
import { get } from 'lodash';
import { useState } from 'react';
import { useAsyncRetry } from 'react-use';
import { SegmentSuggestion } from '../../types';
import GetSugesstionSegment from './api';
import { TDtoGetSugesstionSegment } from './type';

export type TUseGetSugesstionSegment = {
  dto?: TDtoGetSugesstionSegment;
  isLoading?: boolean;
  response?: SegmentSuggestion;
  handleGetSuggestionSegment: (dto: TDtoGetSugesstionSegment) => void;
  handleResetState: () => void;
  onRetry: () => void;
};

const useGetSuggestionSegment = (): TUseGetSugesstionSegment => {
  const [dto, setDto] = useState<TDtoGetSugesstionSegment>();
  const commonActionFromDALV2 = useCommonActionFromDALV2();

  const stateAsyncRetry = useAsyncRetry(async () => {
    if (!dto || !dto.orgId || !dto.suggestionType) return;
    const response: Promise<SegmentSuggestion> = await commonActionFromDALV2(GetSugesstionSegment, dto);
    const result = await response;

    if (!result?.success) CommonNotificationSaveError(get(result, 'message', 'Something went wrong!'));

    return result;
  }, [dto]);

  const handleResetState = () => setDto(undefined);
  const handleGetSuggestionSegment = (dto: TDtoGetSugesstionSegment) => setDto(dto);

  return {
    dto,
    response: stateAsyncRetry?.value,
    handleResetState,
    handleGetSuggestionSegment,
    isLoading: stateAsyncRetry?.loading,
    onRetry: stateAsyncRetry?.retry,
  };
};

export default useGetSuggestionSegment;
